const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/middleware/kisapi/callApi.ts';
/**
 * Http middleware to be used with kisapi redux middleware
 *
 */
import { Store } from 'redux';
import { GenericRequest } from '../genericMiddleware';

/**
 * this function actually calls out to the api
 *
 * @param {Store} gets passed down from middleware and comes from redux framework
 * @param {IAsyncMiddlewareNext} contains function ref to the next transformatio step in the pipeline
 * @param {IKisApiRequest} the object from kisApi key of intercepted action
 * @return {Promise<Response>} http response object
 */
export default function callHttp(_store: Store<any>) {
    return (_next: any) =>
        async (action: GenericRequest): Promise<Response> => {
            try {
                const apiRequest = new Request(action.endpoint, action.requestConfig);
                const response = await fetch(apiRequest);
                return response;
            } catch (failReason) {
                return (Response as any).error();
            }
        };
}
